window.SDK = require('@/utils/NIM_Web_SDK_v6.9.0/js/NIM_Web_SDK_v6.9.0')
import { Toast } from 'vant'
import { session, removeSession, local, removeLocal } from '@/utils/session'
import { getAccidToken } from '@/api/im'

const config = {
  localMsglimit: 20,//聊天室历史记录size
};

const state = {
  nimAppKey: (process.env.NODE_ENV==="development") ? 'f06a2a2d477ce82bf5a5ce9fdc641de2' : 'b0bb4b36ef49e4096948bed7302a5d47',// 云信im的appkey
  account: '',// 云信账号 的 token
  sdktoken: '',// sdk 的 token
  
  nim: null,// NIM SDK 实例
  nimIsLink: false,// im是否连接
  
  address: '',// 聊天室地址
  chatroomId: '',//当前聊天室id
  
  
  // currSessionId: null,// 当前会话ID（即当前聊天列表，只有单聊群聊采用，可用于判别）
  currSessionMsgs: [],
  
  currChatroom: null,// 当前聊天室实例及id
  currChatroomId: null,
  currChatroomMsgs: [],
  // currChatroomInfo: {},
  currEarliestMsg: null,
  // currChatroomMembers: [],// 聊天室成员列表
  noMoreHistoryMsgs: false,//无更多聊天记录
  isSendMsgOK: false,// 是否成功发送消息
}
// +60 167703988 马来西亚号码格式
const mutations = {
  change_nimIsLink: (state, nimIsLink) => {//是否成功登录SDK
    state.nimIsLink = nimIsLink
  },
  change_account: (state, account) => {//云信账号
    state.account = account
  },
  change_sdktoken: (state, sdktoken) => {//SDK的 token
    state.sdktoken = sdktoken
  },
  setCurrChatroom: (state, chatroomId) => {//当前聊天室id
    state.chatroomId = chatroomId
  },
  updateCurrChatroomMsgs(state, obj){ // 处理聊天记录
    let {type, msgs} = Object.assign({}, obj)
    if (type === 'put') {
      msgs.forEach(msg => {
        state.currChatroomMsgs.push(msg)
      })
    } else if (type === 'concat') {
      // 一般用于历史消息拼接
      let currSessionMsgs = obj.msgs
      // currSessionMsgs.reverse()
      currSessionMsgs.forEach(msg => {
        state.currChatroomMsgs.unshift(msg)
      })
    }
    if (state.currChatroomMsgs[0]) {
      state.currEarliestMsg = state.currChatroomMsgs[0]
    }
  },
  setNoMoreHistoryMsgs (state, flag) { // 无更多聊天记录
    state.noMoreHistoryMsgs = flag
  },
  setIsSendMsgOK (state, flag) { // 无更多聊天记录
    state.isSendMsgOK = flag
  },
}

const actions = {
  //初始化 登录SDK
  initNimSDK: ({ state, commit, dispatch }, loginInfo) => {
    commit('change_account', loginInfo.account)
    commit('change_sdktoken', loginInfo.sdktoken)
    if (state.nim) {
      console.log('IM 重新连接前，登出 SDK。')
      state.nim.disconnect()
    }
    window.nim = state.nim = window.SDK.NIM.getInstance({
      debug: false,
      appKey: state.nimAppKey,
      account: state.account,
      token: state.sdktoken,
      db: false,
      onconnect(){
        console.log('IM 连接成功！')
        commit('change_nimIsLink', true)
      },
  
      // onRoamingMsgs(obj) {
      //   console.log('收到漫游消息', obj);
      // },
      // onOfflineMsgs(obj) {
      //   console.log('收到离线消息', obj);
      // },
      // onMsg(msg) {
      //   console.log('收到消息', msg.scene, msg.type, msg);
      // },
      // onOfflineSysMsgs(sysMsgs) {
      //   console.log('收到离线系统通知', sysMsgs);
      // },
      // onSysMsg(sysMsg) {
      //   console.log('收到系统通知', sysMsg)
      // },
      // onUpdateSysMsg(sysMsg) {
      //   console.log('onUpdateSysMsg',sysMsg);
      // },
      // pushSysMsgs(sysMsgs) {
      //   console.log('pushSysMsgs',sysMsgs);
      // },
      // onSysMsgUnread(obj) {
      //   console.log('收到系统通知未读数', obj);
      // },
      // onUpdateSysMsgUnread(obj) {
      //   console.log('系统通知未读数更新了', obj);
      // },
      // refreshSysMsgsUI() {
      //   // 刷新界面
      //   console.log('refreshSysMsgsUI')
      // },
      // onOfflineCustomSysMsgs(sysMsgs) {
      //   console.log('收到离线自定义系统通知', sysMsgs);
      // },
      // onCustomSysMsg(sysMsg) {
      //   console.log('收到自定义系统通知', sysMsg);
      // },
      // onBroadcastMsg(msg) {
      //   console.log('收到广播消息', msg);
      // },
      // onBroadcastMsgs(msgs) {
      //   console.log('收到广播消息onBroadcastMsgs', msgs);
      // }
      
      
    })
  },
  //退出登录 SDK
  logoutSDK: ({ state, commit, dispatch }) => {
    if (state.nim) {
      console.log('退出 nimSDK')
      commit('change_nimIsLink', false)
      state.nim.disconnect()
    }
  },
  //获取聊天室地址
  connectChatroom: ({state, commit, dispatch}, chatroomId) => {
    if (state.nim) {
      state.nim.getChatroomAddress({
        chatroomId,
        done: (error, obj) => {
          if (error) {
            Toast('获取聊天室地址失败！')
            return
          }
          dispatch('initChatroomSDK', obj)
        }
      })
    }
  },
  //初始化聊天室
  initChatroomSDK: ({ state, commit, dispatch }, obj) => {
    // console.log(obj)
    let {chatroomId, address} = obj
    if (chatroomId && address) {
      if (state.currChatroom) {
        state.currChatroom.connect()
      } else {
        state.currChatroom = window.SDK.Chatroom.getInstance({
          appKey: state.nimAppKey,
          account: state.account,
          token: state.sdktoken,
          transports: ['websocket'],
          chatroomId,
          chatroomAddresses: address,
          onconnect: function onChatroomConnect (chatroom) {
            console.log('聊天室已连接！')
            commit('setCurrChatroom', chatroomId)
            const time = state.currChatroomMsgs[0] ? state.currChatroomMsgs[0].time : Date.now();
            dispatch('getChatroomHistoryMsgs', {timetag: time })
          },
          onerror: function onChatroomError (error, obj) {
            if (error) {
              alert('网络连接状态异常，请重试')
            }
          },
          onwillreconnect: function onChatroomWillReconnect (obj) {
            // 此时说明 `SDK` 已经断开连接, 请开发者在界面上提示用户连接已断开, 而且正在重新建立连接
            console.log('即将重连', obj)
          },
          ondisconnect: function onChatroomDisconnect (error) {
            // 此时说明 `SDK` 处于断开状态, 切换聊天室也会触发次回调
            if (error) {
              switch (error.code) {
                // 账号或者密码错误, 请跳转到登录页面并提示错误
                case 302:
                  // 此逻辑与nim sdk错误逻辑相同，复用nim sdk的
                  // 如果单用聊天室功能需要在此做处理
                  break;
                case 13003:
                  alert('抱歉，你已被主播拉入了黑名单')
                  location.href='/mall'
                  break
                // 被踢, 请提示错误后跳转到登录页面
                case 'kicked':
                  if (error.reason === 'managerKick') {
                    alert('你已被管理员移出聊天室')
                    location.href='/mall'
                  } else if (error.reason === 'blacked') {
                    alert('你已被管理员拉入黑名单，不能再进入')
                    location.href='/mall'
                  }
                  break;
                default:
                  console.log(error.message);
                  break
              }
            }
          },
          // 聊天室消息
          onmsgs: function onChatroomMsgs (msgs){
            if (!Array.isArray(msgs)) {
              msgs = [msgs]
            }
            msgs = msgs.map(msg => {
              return formatMsg(msg)
            })
            commit('updateCurrChatroomMsgs', {type: 'put', msgs})
          }
        })
      }
    } else {
      alert('没有聊天室地址')
    }
  },
  //获取历史聊天记录
  getChatroomHistoryMsgs: ({state, commit, dispatch}, obj) => {
    const chatroom = state.currChatroom
    if (chatroom) {
      console.log('聊天历史记录时间点：' + obj.timetag)
      let {timetag} = Object.assign({}, obj)
      let options = {
        timetag,
        msgTypes: ['text', 'image', 'audio', 'video'],
        limit: config.localMsglimit || 20,
        done: function getChatroomHistoryMsgsDone (error, obj) {
          if (obj.msgs) {
            if (obj.msgs.length === 0) {
              commit('setNoMoreHistoryMsgs', true)
              console.log('无更多聊天记录')
            } else {
              let msgs = obj.msgs.map(msg => {
                return formatMsg(msg)
              })
              commit('updateCurrChatroomMsgs', {
                type: 'concat',
                msgs
              })
            }
          }
        }
      }
      state.currChatroom.getHistoryMsgs(options)
    }
  },
  //聊天室发送消息
  sendChatroomMsg({state, commit, dispatch}, obj){
    const chatroom = state.currChatroom
    if (chatroom) {
      let {text} = Object.assign({}, obj)
      let options = {
        text,
        done: function sendChatroomMsgDone (error, msg) {
          if(error){
            Toast('发送消息失败' + error)
            return
          }
          let msgs = [formatMsg(msg)]
          commit('setIsSendMsgOK', true)
          commit('updateCurrChatroomMsgs', {
            type: 'put',
            msgs
          })
        }
      }
      state.currChatroom.sendText(options)
    }
  }
}


function formatMsg (msg) {
  const nim = state.nim
  msg.isSelf = (msg.from===state.account) //判断是否自己发言
  if (msg.type === 'robot') {
    if (msg.content && msg.content.flag === 'bot') {
      if (msg.content.message) {
        msg.content.message = msg.content.message.map(item => {
          switch (item.type) {
            case 'template':
              item.content = nim.parseRobotTemplate(item.content)
              break
            case 'text':
            case 'image':
            case 'answer':
              break
          }
          return item
        })
      }
    }
  }
  return msg
}






export default {
  namespaced: true,
  state,
  mutations,
  actions
}



